// BM-H4056 - the client's answers as staff read them on "View submission".
//
// Replaces a JSON.stringify dump that UAT failed (Script 1 Part C step 2, 8 Oct 2026): staff
// could not compare lpa_kind "pf", ids and true/false flags against a test data sheet. LPA
// answers get the labelled, sectioned summary from lpa/lpaAnswersSummary.js; any other form
// kind gets the same readable rows built generically. The raw data stays available behind a
// closed "Technical data" toggle for support, out of the way.

import { buildGenericSummary, buildLpaSummary } from "./lpa/lpaAnswersSummary";

const sectionTitle = { fontSize: 13, margin: "0 0 8px", color: "#334155", textTransform: "uppercase", letterSpacing: 0.4 };
const dl = { display: "grid", gridTemplateColumns: "minmax(140px, 38%) minmax(0, 1fr)", gap: "4px 12px", margin: 0 };
const dt = { fontSize: 13, color: "#64748b" };
const dd = { fontSize: 13, color: "#0f172a", margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" };
const card = { border: "1px solid #e2e8f0", borderRadius: 8, padding: 10, marginTop: 8 };
const muted = { fontSize: 13, color: "#64748b", margin: "4px 0 0" };

function Rows({ rows, testid }) {
  if (!rows || rows.length === 0) return null;
  return (
    <dl style={dl} data-testid={testid}>
      {rows.map((r, i) => (
        // Label and value are siblings in a two column grid.
        <div key={`${r.label}-${i}`} style={{ display: "contents" }}>
          <dt style={dt}>{r.label}</dt>
          <dd style={dd}>{r.value}</dd>
        </div>
      ))}
    </dl>
  );
}

// eslint-disable-next-line react/prop-types
export default function ClientAnswersSummary({ answers, engineKind }) {
  const sections = (engineKind || "wills") === "lpa" ? buildLpaSummary(answers) : buildGenericSummary(answers);
  const nothing = sections.every((s) => (s.rows || []).length === 0 && (s.people || []).length === 0);

  return (
    <div data-testid="client-answers-summary">
      {nothing && <p style={muted} data-testid="client-answers-empty">The client has not entered any answers yet.</p>}
      {!nothing && sections.map((s) => (
        <div key={s.id} data-testid={`answers-section-${s.id}`} style={{ marginBottom: 18 }}>
          <h3 style={sectionTitle}>{s.title}</h3>
          <Rows rows={s.rows} />
          {(s.people || []).map((p, i) => (
            <div key={`${p.heading}-${i}`} style={card} data-testid={`answers-card-${s.id}-${i}`}>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#0f172a", marginBottom: 6 }}>{p.heading}</div>
              <Rows rows={p.rows} />
            </div>
          ))}
          {s.emptyPeople && <p style={muted}>{s.emptyPeople}</p>}
        </div>
      ))}
      <details data-testid="client-answers-technical" style={{ marginTop: 12 }}>
        <summary style={{ fontSize: 12, color: "#64748b", cursor: "pointer" }}>Technical data (for IT support only)</summary>
        <pre
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            background: "#f8fafc",
            padding: 12,
            borderRadius: 8,
            fontSize: 11,
            lineHeight: 1.5,
            maxHeight: 400,
            overflow: "auto",
            color: "#0f172a",
          }}
        >
          {JSON.stringify(answers || {}, null, 2)}
        </pre>
      </details>
    </div>
  );
}
